import { render, staticRenderFns } from "./WithdrawInfoForm.vue?vue&type=template&id=4ed7bc87&scoped=true"
import script from "./WithdrawInfoForm.vue?vue&type=script&lang=js"
export * from "./WithdrawInfoForm.vue?vue&type=script&lang=js"
import style0 from "./WithdrawInfoForm.vue?vue&type=style&index=0&id=4ed7bc87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed7bc87",
  null
  
)

export default component.exports